module.exports = __webpack_public_path__ + "img/HKK_2_0.b864293a.png";